<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditSubcategoriaContaModal
      v-if="showCreateEditSubcategoriaContaModal"
      :subcategoriaContaId="subcategoriaContaIdSelected"
      @closeModal="closeCreateEditSubcategoriaContaModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Subcategorias de Contas</h5>
        <div v-if="getModuleUserByCode('2.02.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Nova Subcategoria"
            @click="createEditSubcategoriaConta()"
          >
            <i class="ri-add-fill align-middle"></i>Nova Subcategoria
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListSubcategoriasContas
          :subcategorias="subcategorias"
          @editSubcategoriaConta="createEditSubcategoriaConta"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import CreateEditSubcategoriaContaModal from '@/components/financeiro/categoriasContas/CreateEditSubcategoriaContaModal.vue'
import ListSubcategoriasContas from '@/components/financeiro/categoriasContas/ListSubcategoriasContas.vue'

export default {
  name: 'SubcategoriasContas',

  components: {
    Layout,
    PageHeader,
    CreateEditSubcategoriaContaModal,
    LoadingData,
    ListSubcategoriasContas,
  },

  data() {
    return {
      title: 'Subcategorias de Contas',
      items: [
        {
          text: 'Subcategorias',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditSubcategoriaContaModal: false,
      subcategorias: null,
      subcategoriaContaIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getSubcategoriasContas() {
      try {
        this.subcategorias = await this.$store.dispatch(
          'getSubcategoriasContas',
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditSubcategoriaConta(subcategoriaContaId) {
      this.subcategoriaContaIdSelected = subcategoriaContaId || null
      this.showCreateEditSubcategoriaContaModal = true
    },

    closeCreateEditSubcategoriaContaModal(loadListSubcategoriasContas) {
      if (loadListSubcategoriasContas) {
        this.getSubcategoriasContas()
      }
      this.showCreateEditSubcategoriaContaModal = false
    },
  },

  mounted() {
    this.getSubcategoriasContas()
  },
}
</script>
